/**
 * Shared utilities for accessing the current user from Rails helpers.
 * Used by all template select wrappers (Email, SMS, Appointment, Task).
 */

export const isAdminUser = () =>
  Rails?.helpers?.currentUser?.role?.name === "admin";

export const getCurrentUserId = () => Rails?.helpers?.currentUser?.id || null;
